import React from 'react';
import DisclosedProfile from '../DisclosedProfile/DisclosedProfile';
import AnonymizedProfile from '../AnonymizedProfile/AnonymizedProfile';
import { MarketplaceSellerProfile } from '../../../slices/profiles-data-slice/models/marketplace-seller-profile';
import './SellerProfileWrapper.scss';

interface SellerProfileWrapperProps {
    isDisclosed: boolean;
    profileData?: MarketplaceSellerProfile;
    timelineId?: number;
}

const SellerProfileWrapper: React.FC<SellerProfileWrapperProps> = (props) => {
    const { isDisclosed, profileData, timelineId } = props;

    return (
        <div className="seller-profile-wrapper">
            {isDisclosed ? (
                <DisclosedProfile profileData={profileData} timelineId={timelineId} />
            ) : (
                <AnonymizedProfile profileData={profileData} timelineId={timelineId} />
            )}
        </div>
    );
};

export default SellerProfileWrapper;
